<form
  [formGroup]="form"
  [mojoFormConnect]="job"
  class="d-flex"
>
  <mat-form-field
    color="accent"
    class="status"
  >
    <mat-label>Job status</mat-label>
    <mat-select
      formControlName="status"
      data-cy="job-status-status-select"
    >
      <mat-option
        *ngFor="let item of statusList"
        [value]="item"
      >
        {{ item }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
